import React from 'react';
import { Grid2 } from '@mui/material';
import { ArcGridProps } from './types';

const ArcGrid: React.FC<ArcGridProps> = (props) => {
  return <Grid2 {...props} />;
};

export default ArcGrid;